import React, { useState } from "react";
import { Link } from "react-router-dom";
import Card from "../Card/Card";

function Search() {
  const [togle, settogle] = useState(1);

  function onchange(id) {
    settogle(id);
  }

  return (
    <div className="cantainer snap-start  justify-center pt-40">
      <div className="main_link list-none d-flex text-sm ml-6">
        <li className="p-2" onClick={() => onchange(1)}>
          WOMEN
        </li>
        <li className="p-2" onClick={() => onchange(2)}>
          MEN
        </li>
        <li className="p-2" onClick={() => onchange(3)}>
          KIDS
        </li>
      </div>
      <input
        type="search"
        className=" mr-20 mb-2 m-8 text-xs w-80 p-2 focus:outline-none hover:outline-none border-black border-b-2 text-start"
        placeholder="SEARCH FOR AN ITEM.COLOUR, COLLECTION..."
      />

      {/* Women */}
      <div className={togle === 1 ? "d-block" : "d-none "}>
        <div className="container">
          <div className="row">
            <div className="col-md-4 m-0 p-0">
              <div className="d-flex">
                <Link to="">
                  <Card
                    imgUrl2="./image/women/1.jpg"
                    img="./image/women/22.jpg"
                    title="100 USD "
                  />
                </Link>

                <Link to="">
                  <Card
                    imgUrl2="./image/women/2.jpg"
                    img="./image/women/21.jpg"
                    title="100 USD "
                  />
                </Link>
              </div>
            </div>
            <div className="col-md-4 m-0 p-0">
              <div className="d-flex">
                <Link to="">
                  <Card
                    imgUrl2="./image/women/3.jpg"
                    img="./image/women/20.jpg"
                    title="100 USD "
                  />
                </Link>

                <Link to="">
                  <Card
                    imgUrl2="./image/women/19.jpg"
                    img="./image/women/15.jpg"
                    title="100 USD "
                  />
                </Link>
              </div>
            </div>
            <div className="col-md-4 m-0 p-0">
              <div className="d-flex">
                <Link to="">
                  <Card
                    imgUrl2="./image/women/18.jpg"
                    img="./image/women/13.jpg"
                    title="100 USD "
                  />
                </Link>

                <Link to="">
                  <Card
                    imgUrl2="./image/women/17.jpg"
                    img="./image/women/10.jpg"
                    title="100 USD "
                  />
                </Link>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4 m-0 p-0 ">
              <div className="d-flex">
                <Link to="">
                  <Card
                    imgUrl2="./image/women/1.jpg"
                    img="./image/women/22.jpg"
                    title="100 USD "
                  />
                </Link>

                <Link to="">
                  <Card
                    imgUrl2="./image/women/12.jpg"
                    img="./image/women/21.jpg"
                    title="100 USD "
                  />
                </Link>
              </div>
            </div>
            <div className="col-md-4 m-0 p-0">
              <div className="d-flex">
                <Link to="">
                  <Card
                    imgUrl2="./image/women/13.jpg"
                    img="./image/women/16.jpg"
                    title="100 USD "
                  />
                </Link>

                <Link to="">
                  <Card
                    imgUrl2="./image/women/14.jpg"
                    img="./image/women/11.jpg"
                    title="100 USD "
                  />
                </Link>
              </div>
            </div>
            <div className="col-md-4 m-0 p-0">
              <div className="d-flex">
                <Link to="">
                  <Card
                    imgUrl2="./image/women/15.jpg"
                    img="./image/women/8.jpg"
                    title="100 USD "
                  />
                </Link>

                <Link to="">
                  <Card
                    imgUrl2="./image/women/14.jpg"
                    img="./image/women/7.jpg"
                    title="100 USD "
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* women */}

      {/* men */}
      <div className={togle === 2 ? "d-block" : "d-none"}>
        <div className="container">
          <div className="row">
            <div className="col-md-4 m-0 p-0">
              <div className="d-flex">
                <Link to="">
                  <Card
                    imgUrl2="./image/men/1.jpg"
                    img="./image/men/20.jpg"
                    title="100 USD "
                  />
                </Link>

                <Link to="">
                  <Card
                    imgUrl2="./image/men/2.jpg"
                    img="./image/men/21.jpg"
                    title="100 USD "
                  />
                </Link>
              </div>
            </div>
            <div className="col-md-4 m-0 p-0">
              <div className="d-flex">
                <Link to="">
                  <Card
                    imgUrl2="./image/men/3.jpg"
                    img="./image/men/10.jpg"
                    title="100 USD "
                  />
                </Link>

                <Link to="">
                  <Card
                    imgUrl2="./image/men/19.jpg"
                    img="./image/men/15.jpg"
                    title="100 USD "
                  />
                </Link>
              </div>
            </div>
            <div className="col-md-4 m-0 p-0">
              <div className="d-flex">
                <Link to="">
                  <Card
                    imgUrl2="./image/men/18.jpg"
                    img="./image/men/13.jpg"
                    title="100 USD "
                  />
                </Link>

                <Link to="">
                  <Card
                    imgUrl2="./image/men/17.jpg"
                    img="./image/men/10.jpg"
                    title="100 USD "
                  />
                </Link>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4 m-0 p-0 ">
              <div className="d-flex">
                <Link to="">
                  <Card
                    imgUrl2="./image/men/1.jpg"
                    img="./image/men/22.jpg"
                    title="100 USD "
                  />
                </Link>

                <Link to="">
                  <Card
                    imgUrl2="./image/men/12.jpg"
                    img="./image/men/21.jpg"
                    title="100 USD "
                  />
                </Link>
              </div>
            </div>
            <div className="col-md-4 m-0 p-0">
              <div className="d-flex">
                <Link to="">
                  <Card
                    imgUrl2="./image/men/13.jpg"
                    img="./image/men/16.jpg"
                    title="100 USD "
                  />
                </Link>

                <Link to="">
                  <Card
                    imgUrl2="./image/men/14.jpg"
                    img="./image/men/11.jpg"
                    title="100 USD "
                  />
                </Link>
              </div>
            </div>
            <div className="col-md-4 m-0 p-0">
              <div className="d-flex">
                <Link to="">
                  <Card
                    imgUrl2="./image/men/15.jpg"
                    img="./image/men/8.jpg"
                    title="100 USD "
                  />
                </Link>

                <Link to="">
                  <Card
                    imgUrl2="./image/men/14.jpg"
                    img="./image/men/7.jpg"
                    title="100 USD "
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* men */}

      {/* kids */}
      <div className={togle === 3 ? "d-block" : "d-none"}>
        <div className="container">
          <div className="row">
            <div className="col-md-4 m-0 p-0">
              <div className="d-flex">
                <Link to="">
                  <Card
                    imgUrl2="./image/kid/kid1.jpg"
                    img="./image/kid/kid7.jpg"
                    title="100 USD "
                  />
                </Link>

                <Link to="">
                  <Card
                    imgUrl2="./image/kid/kid2.jpg"
                    img="./image/kid/kid6.jpg"
                    title="100 USD "
                  />
                </Link>
              </div>
            </div>
            <div className="col-md-4 m-0 p-0">
              <div className="d-flex">
                <Link to="">
                  <Card
                    imgUrl2="./image/kid/kid2.jpg"
                    img="./image/kid/kid6.jpg"
                    title="100 USD "
                  />
                </Link>

                <Link to="">
                  <Card
                    imgUrl2="./image/kid/kid2.jpg"
                    img="./image/kid/kid6.jpg"
                    title="100 USD "
                  />
                </Link>
              </div>
            </div>
            <div className="col-md-4 m-0 p-0">
              <div className="d-flex">
                <Link to="">
                  <Card
                    imgUrl2="./image/kid/kid2.jpg"
                    img="./image/kid/kid6.jpg"
                    title="100 USD "
                  />
                </Link>

                <Link to="">
                  <Card
                    imgUrl2="./image/kid/kid2.jpg"
                    img="./image/kid/kid6.jpg"
                    title="100 USD "
                  />
                </Link>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4 m-0 p-0 ">
              <div className="d-flex">
                <Link to="">
                  <Card
                    imgUrl2="./image/kid/kid2.jpg"
                    img="./image/kid/kid6.jpg"
                    title="100 USD "
                  />
                </Link>

                <Link to="">
                  <Card
                    imgUrl2="./image/kid/kid2.jpg"
                    img="./image/kid/kid6.jpg"
                    title="100 USD "
                  />
                </Link>
              </div>
            </div>
            <div className="col-md-4 m-0 p-0">
              <div className="d-flex">
                <Link to="">
                  <Card
                    imgUrl2="./image/kid/kid2.jpg"
                    img="./image/kid/kid6.jpg"
                    title="100 USD "
                  />
                </Link>

                <Link to="">
                  <Card
                    imgUrl2="./image/kid/kid2.jpg"
                    img="./image/kid/kid6.jpg"
                    title="100 USD "
                  />
                </Link>
              </div>
            </div>
            <div className="col-md-4 m-0 p-0">
              <div className="d-flex">
                <Link to="">
                  <Card
                    imgUrl2="./image/kid/kid2.jpg"
                    img="./image/kid/kid6.jpg"
                    title="100 USD "
                  />
                </Link>

                <Link to="">
                  <Card
                    imgUrl2="./image/kid/kid2.jpg"
                    img="./image/kid/kid6.jpg"
                    title="100 USD "
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* kids */}
    </div>
  );
}

export default Search;
